import './style.scss';
import PhoneInput from 'react-phone-input-2';
import { useNavigate } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { IoCloseOutline } from 'react-icons/io5';
import FormControl from '../../common/FormControl';
import methodModel from '../../../methods/methods';

function Html({
  handleSubmit,
  setForm,
  form,
  setEditTabSet,
  ImageUpload,
}) {
  const history = useNavigate();

  return (
    <div className="wrapper_section">
      <div className="flex items-center justify-between gap-2 mb-5">
        <h3 className="text-2xl font-semibold text-[#111827]">
          Edit Profile
        </h3>
      </div>
      <form name="profileForm" onSubmit={handleSubmit}>
        <div className='flex max-lg:flex-wrap gap-5 sm:gap-8 bg-[#FAFAFA] rounded-[12px] p-5 sm:p-8'>
          <div className='w-full lg:max-w-[350px] w-full bg-white shadow-[0px_3px_14px_-8px_#888888] text-center rounded-[12px] p-5 sm:p-8'>
             <div>
              {form?.image ? (
                  <div className="relative w-fit h-fit mx-auto">
                    <img src={methodModel.userImg(form?.image)} className="w-28 h-28 mx-auto rounded-full border-4 border-[#CC9900] object-cover" />
                    <IoCloseOutline className="absolute right-[8px] bottom-[5px] w-[22px] h-[22px] text-red rounded-full border border-red cursor-pointer hover:bg-[#ffefef] bg-white p-[2px]" onClick={(e) => setForm({ ...form, image: '' })} size={25} />
                  </div>
              ) : (
                <label className="bg-primary leading-10 h-10 flex justify-center  items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-full gap-1 cursor-pointer min-w-[94px]" style={{ gap: '8px' }}>
                  <input
                    id="dropzone-file"
                    type="file"
                    className="hidden"
                    onChange={ImageUpload}
                  />
                  Upload Image
                </label>
              )}
               <div className='space-y-2 mt-4'>
<h2 class="text-2xl font-bold text-gray-800">{form?.firstName} {form?.lastName}</h2>
<p class="text-gray-500">{form?.email}</p>
                    </div>
             </div>
          </div>
            <div className='w-full bg-white shadow-[0px_3px_14px_-8px_#888888] rounded-[12px] p-5 sm:p-8'>
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 md:col-span-6">
            <FormControl
              type="text"
              label="First Name"
              value={form?.firstName}
              onChange={(e) => setForm({ ...form, firstName: e })}
              required
            />
          </div>
          <div className="col-span-12 md:col-span-6">
            <FormControl
              type="text"
              label="Last Name"
              value={form?.lastName}
              onChange={(e) => setForm({ ...form, lastName: e })}
              required
            />
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="text-sm mb-2 block text-[#2D2D2D]">
              Email
              <span className="text-red-600">*</span>
            </label>
            <input
              type="email"
              className="relative  bg-[#F7F7F7] w-full rounded-lg h-10 focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 px-3 disabled:cursor-not-allowed"
              value={form?.email}
              autoComplete="false"
              disabled
            />
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="text-sm mb-2 block text-[#2D2D2D]">
              Mobile No
              <span className="star">*</span>
            </label>
            <div className='form_controlinput '>
            <PhoneInput
              country=""
              value={form.mobileNo}
              enableSearch
              onChange={(e) => setForm({ ...form, mobileNo: e })}
              inputProps={{ required: true }}
              countryCodeEditable
            />
            </div>
          </div>
      
        </div>
        </div>
        </div>
          
        

        <div className="flex gap-2 justify-end mt-6">
          <button type="button" onClick={() => setEditTabSet(false)} className="bg-white leading-10 h-10 flex justify-center  items-center shadow-btn px-6 hover:opacity-80 text-sm text-[#C2C2C2] rounded-full gap-1 cursor-pointer border border-[#D2D2D2] min-w-[94]">
            Cancel
          </button>
          <button className="bg-primary leading-10 h-10 flex justify-center  items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-full gap-1 cursor-pointer min-w-[94px]">
            Save
          </button>
        </div>
      </form>
    </div>
  );
}

export default Html;
